import '../GlowSubWidgets.css';
import React from "react";

function FocusHelp(props) {
    const helpIdeas = [
        "step away for 5-10 minutes",
        "change your environment",
        "do something tactile",
        "drink a glass of water ",
        "brain dump - write your thoughts",
        "do your easiest task, now",
        "start some handpan music"
    ]
    return (
        <div className="">
            <p className="glowHeaderText"> lets refocus </p>
            {/* TODO  we want this to be more random, like it randomly selects one and you can switch it  */}
            <p className="refocusHelpText"> try one of the following: </p>
            {helpIdeas.map((idea, index) => (
                <p key={index} className="refocusHelpText"> {idea} </p>
            ))}
        </div>
    )
}

export default FocusHelp;